import React, { useContext, useEffect } from "react";
import { formatDateWithTime } from "Common/HelperClass";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import TableSkeletonElement from "Components/GMS/Products/components/TableSkeletonElement.js";
import { PivotSortableColumn } from "../constants/CSConstants";
import TdElement from "./TdElement";
import { CSContext } from "../contexts/CSContext";
import { sortTableField } from "../utils/CSHelper";
import NoDataComponent from "Components/Common/NoDataComponent";



function CSVersionTable(props: any) {
    const { pivotVersionList, loading, handlePivotData } = useContext(CSContext)

    const [sortColumn, setSortColumn] = useState<PivotSortableColumn | null>(null);
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");


    const history = useHistory();

    const sortedData = sortTableField([...pivotVersionList ?? []], sortColumn, sortDirection)


    const handleSort = (column: PivotSortableColumn) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortDirection("asc");
        }
    };


    const sortElement = (column: string) => {
        return sortColumn === column ? (
            <span className="tw-ml-1">
                {sortDirection === "asc" ? (
                    <i className="fas fa-sort-up" />
                ) : (
                    <i className="fas fa-sort-down" />
                )}
            </span>
        ) : (
            <i className="fas fa-sort" />
        );
    };

    useEffect(() => {
        handlePivotData(sortedData[props?.selectedIndex])
    }, [props?.selectedIndex])

    if (loading) { return <div className=""><TableSkeletonElement /></div> }

    if (loading === false && pivotVersionList?.length === 0) { return <div><NoDataComponent /></div> }

    return (<>
        <div className="tw-border tw-border-solid tw-mt-3 tw-border-[#DFE0E6] tw-border-r-2 tw-rounded ">
            <div className="table-container" style={{ width: '100%', height: 'auto', overflowX: 'auto' }}>
                <table className="tw-bg-[#DFE1E6] tw-w-full">
                    <thead className="tw-sticky tw-top-0 tw-bg-[#DFE1E6]">
                        <tr>
                            <th className="table-header-style tw-w-2"  >   </th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.CATEGORY)}  >    {"CATEGORY"}    {sortElement(PivotSortableColumn.CATEGORY)}</th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.VERSION)}  >     {"IDENTIFIER"}     {sortElement(PivotSortableColumn.VERSION)} </th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.TOTAL_ATTRIBUTES)}   >{"TOTAL ATTRIBUTES"} {sortElement(PivotSortableColumn.ATTRIBUTES)}</th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.ATTRIBUTES)}   >{"ATTRIBUTES"} {sortElement(PivotSortableColumn.ATTRIBUTES)}</th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.CREATED_ON)}   >{"CREATED ON"} {sortElement(PivotSortableColumn.CREATED_ON)}</th>
                            <th className="table-header-style" onClick={() => handleSort(PivotSortableColumn.LAST_UPDATED_BY)}  > {"LAST UPDATED BY"} {sortElement(PivotSortableColumn.LAST_UPDATED_BY)}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                            sortedData?.map((responseItem, defaultIndex) => {
                                    return <>
                                        {
                                            <tr key={responseItem.uid} className="hover:bg-gray-100">
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, <input type="radio" name={`radio-group-${defaultIndex}`} checked={props?.selectedIndex === defaultIndex} onChange={() => {
                                                    props?.setSelectedIndex(defaultIndex)
                                                    handlePivotData(sortedData[defaultIndex])
                                                }} />)}
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null },
                                                    <div className="tw-flex tw-items-center tw-justify-start" >
                                                        <div className="tw-text-blue-700 tw-text-sm  tw-leading-tight tw-cursor-pointer"
                                                            onClick={() => { history.push(`ars/model/${responseItem?.category_id}`); }}>{responseItem?.category_name ?? ""}
                                                        </div>
                                                    </div>)}
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, <div className="tw-text-blue-950 tw-text-sm  tw-leading-tight">{responseItem.version_name}</div>)}
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, <div className="tw-text-blue-950 tw-text-sm  tw-leading-tight tw-overflow-hidden tw-truncate w-2">{responseItem.attribute.split(",").length}</div>)}

                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, <div className="tw-text-blue-950 tw-text-sm  tw-leading-tight tw-overflow-hidden tw-truncate w-2">{responseItem.attribute}</div>)}
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, formatDateWithTime(responseItem?.created_on) || "")}
                                                {TdElement({ defaultIndex: defaultIndex, versionIndex: null }, responseItem?.updated_by?.username)}
                                            </tr>
                                        }
                                    </>
                                })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </>
    );
}

export default CSVersionTable